const LOCALSTORAGE_STUDENT_MODE = `${process.env.APPLICATION_ALIAS}_studentMode`;

const _getStudentModeLocalStorage = () => {
  const data = JSON.parse(localStorage.getItem(LOCALSTORAGE_STUDENT_MODE));

  return !data ? [] : data;
};

const getStudentModeData = () => {
  const localStorageData = _getStudentModeLocalStorage();

  return localStorageData;
};

const getStudentModeCurrentSessionData = (id) => {
  const data = getStudentModeData();
  let studentModeCurrentSession = null;

  if (Array.isArray(data)) {
    studentModeCurrentSession = data.find(item => item.previewUser.id === id);
  } else {
    studentModeCurrentSession = data.previewUser.id === id ? data : null;
  }

  return studentModeCurrentSession;
};

const _saveStudentModeLocalStorage = params => {
  const studentModeData = _getStudentModeLocalStorage();

  if (Array.isArray(params)) {
    localStorage.setItem(LOCALSTORAGE_STUDENT_MODE, JSON.stringify(params));
    return;
  }

  const studentModeSessionIndexToReplace = studentModeData.findIndex(item => item.originUser.id === params.originUser.id);
  if (studentModeSessionIndexToReplace > -1) {
    studentModeData.splice(studentModeSessionIndexToReplace, 1, params);
  } else {
    studentModeData.push(params);
  }

  localStorage.setItem(LOCALSTORAGE_STUDENT_MODE, JSON.stringify(studentModeData));
};

const saveStudentMode = params => {
  _saveStudentModeLocalStorage(params);
};

module.exports = {
  getStudentModeData,
  getStudentModeCurrentSessionData,
  saveStudentMode
};
